import { baseColors } from "@Constants/baseStyles"
import * as React from "react"
import Svg, { Path } from "react-native-svg"

function SvgCourse(props) {
    return (
        <Svg
            width={props.size ?? 20}
            height={props.size ?? 20}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <Path
                d="M4.727 2.676h-2.97a.586.586 0 100 1.172h2.97a.586.586 0 100-1.172zM4.727 7.363h-2.97a.586.586 0 100 1.172h2.97a.586.586 0 100-1.172zM3.555 5.02H.585a.586.586 0 100 1.171h2.97a.586.586 0 100-1.171zM18.828 7.95h-3.555V5.604c0-1.029-1.258-1.57-2-.828L8.586 9.464a1.171 1.171 0 000 1.657l2.687 2.688L8 17.08a1.171 1.171 0 101.657 1.658l4.101-4.102c.458-.458.458-1.2 0-1.657l-2.687-2.687 1.859-1.859v.687c0 .647.524 1.172 1.172 1.172h4.726a1.172 1.172 0 000-2.344zM10.943 1.994a1.172 1.172 0 00-1.479.146L6.242 5.363A1.171 1.171 0 107.899 7.02l2.543-2.544.857.617 1.145-1.144a2.33 2.33 0 01.664-.456l-2.165-1.5z"
                fill={props.color ? props.color : baseColors.green.primary}
            />
            <Path
                d="M7.757 11.95a2.323 2.323 0 01-.6-1.057L.968 17.082a1.171 1.171 0 101.657 1.657l5.96-5.96-.828-.829zM15.86 4.434a1.758 1.758 0 100-3.516 1.758 1.758 0 000 3.516z"
                fill={props.color ? props.color : baseColors.green.primary}
            />
        </Svg>
    )
}

export default SvgCourse
